/* ═══════════════════════════════════════════════════════════════════════
   FizzyIQ — Frosted-glass cart drawer
   Port of /design_handoff_cart_drawer/. Dawn-native — uses the live
   Shopify cart (not localStorage), refreshes via the Section Rendering
   API (`?sections=fizzy-cart-drawer`), and exposes a small public API.

   Open triggers (delegated):
     • [data-open-cart]            — explicit attribute (preferred)
     • a.cart-pill (no href= /cart) — header cart button
   Close triggers:
     • [data-close]                — scrim + close button
     • Escape key

   Mutations call Shopify cart endpoints, then re-fetch the section HTML
   and replace the body/count/subtotal/checkout fields in place.

   Public API (window.FizzyCart):
     open()         — open the drawer
     close()        — close it
     refresh()      — fetch the section; resolve {ok:true} or {ok:false}
     add(formData)  — POST to /cart/add.js, then refresh + open
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__fizzyCartDrawerInit) return;
  window.__fizzyCartDrawerInit = true;

  var SECTION_ID = 'fizzy-cart-drawer';
  var FLAVOR_MAP = {
    'Berry Cherry':        { sw: '#2C4A8B', img: 'fizzy-pouch-bc.png' },
    'Strawberry Lemonade': { sw: '#C8323C', img: 'fizzy-pouch-sl.png' },
    'Watermelon':          { sw: '#0A5D56', img: 'fizzy-pouch-wm.png' },
    'Orange Creamsicle':   { sw: '#C23A12', img: 'fizzy-pouch-ob.png' }
  };

  /* ── helpers ──────────────────────────────────────────────────────── */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function syncBubbles(count) {
    $$('.cart-pill .bubble, [data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  /* ── modal state and recovery ─────────────────────────────────────── */
  function root() { return document.getElementById('fizzyCartDrawer'); }
  var opener = null;
  var previousOverflow = '';
  var inerted = [];
  var backgroundObserver = null;
  var refreshQueue = Promise.resolve();
  var refreshPending = 0;
  var mutationPending = false;
  var stale = false;
  var retryAction = null;
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function visible(el) {
    return !!(el && el.isConnected && !el.closest('[hidden], [inert]') &&
      el.getClientRects().length && window.getComputedStyle(el).visibility !== 'hidden');
  }
  function focusable(el) {
    return $$(FOCUSABLE, el).filter(function (node) { return !node.disabled && visible(node); });
  }
  function focus(el) { if (el && typeof el.focus === 'function') el.focus({ preventScroll: true }); }
  function isOpen() { var el = root(); return !!(el && el.classList.contains('open')); }

  /* This drawer shares overlay events and its animated stacking layer with
     the site. Isolate siblings along its ancestor path, never its ancestors. */
  function isolateBackground() {
    var branch = root();
    while (branch && branch !== document.body) {
      var parent = branch.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling !== branch && !sibling.hasAttribute('inert') &&
            !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sibling.tagName)) {
          sibling.setAttribute('inert', '');
          inerted.push(sibling);
        }
      });
      branch = parent;
    }
  }
  function restoreBackground() {
    if (backgroundObserver) backgroundObserver.disconnect();
    backgroundObserver = null;
    inerted.forEach(function (el) { el.removeAttribute('inert'); });
    inerted = [];
  }

  function open(trigger) {
    var el = root();
    if (!el || isOpen()) return;
    opener = trigger && trigger.nodeType === 1 ? trigger : document.activeElement;
    // Other overlays restore their scroll state before the cart takes ownership.
    document.dispatchEvent(new CustomEvent('fizzy:overlay-open', { detail: 'cart' }));
    previousOverflow = document.body.style.overflow;
    el.removeAttribute('inert');
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    focus($('.fcd-x', el));
    isolateBackground();
    if (window.MutationObserver) {
      backgroundObserver = new MutationObserver(isolateBackground);
      backgroundObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  function close(restoreFocus) {
    var el = root();
    if (!el || !isOpen()) return;
    el.classList.remove('open');
    restoreBackground();
    document.body.style.overflow = previousOverflow;
    if (restoreFocus !== false) {
      var target = visible(opener) && opener.matches(FOCUSABLE) && !opener.disabled ? opener : $('[data-open-cart], a.cart-pill');
      if (visible(target)) focus(target);
    } else if (el.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    el.setAttribute('inert', '');
    el.setAttribute('aria-hidden', 'true');
    opener = null;
  }

  document.addEventListener('fizzy:overlay-open', function (e) {
    if (e && e.detail !== 'cart') close(false);
  });

  function announce(message) {
    var status = $('[data-fcd-status]', root());
    if (status) status.textContent = message;
  }
  function syncBusy() {
    var el = root();
    if (!el) return;
    var busy = mutationPending || refreshPending > 0;
    el.classList.toggle('is-updating', busy);
    el.classList.toggle('is-stale', stale);
    var list = $('[data-fcd-list]', el);
    if (list) list.setAttribute('aria-busy', busy ? 'true' : 'false');
    $$('.fcd-checkout, [data-disc-apply]', el).forEach(function (button) {
      button.disabled = busy || stale || el.classList.contains('empty');
    });
    $$('[data-fcd-inc], [data-fcd-dec], [data-fcd-rm], [data-fcd-upsell-add]', el).forEach(function (button) {
      if (busy || stale) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    });
    var retry = $('[data-fcd-retry]', el);
    if (retry) retry.disabled = busy;
  }
  function clearError() {
    var box = $('[data-fcd-error]', root());
    if (box) box.hidden = true;
    retryAction = null;
  }
  function showError(message, retry) {
    var el = root();
    var box = $('[data-fcd-error]', el);
    var copy = $('[data-fcd-error-message]', el);
    if (copy) copy.textContent = message;
    if (box) box.hidden = false;
    retryAction = retry || function () { return refresh(); };
    syncBusy();
  }

  function request(url, options) {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 20000) : null;
    var settings = Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options || {});
    if (controller) settings.signal = controller.signal;
    return fetch(url, settings).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || (data && Number(data.status) >= 400)) {
          var message = data && (data.description || data.message);
          throw new Error(typeof message === 'string' ? message : 'The cart could not be updated.');
        }
        return data;
      });
    }).finally(function () { if (timer) clearTimeout(timer); });
  }

  function findLine(key, el) {
    return $$('[data-fcd-item]', el).find(function (line) { return line.getAttribute('data-line-key') === key; });
  }
  function captureFocus(el) {
    var active = document.activeElement;
    if (!el.contains(active)) return null;
    var line = active.closest('[data-fcd-item]');
    var selectors = ['[data-fcd-inc]', '[data-fcd-dec]', '[data-fcd-rm]', '[data-fcd-bundle-toggle]'];
    return {
      element: active,
      key: line && line.getAttribute('data-line-key'),
      index: line ? $$('[data-fcd-item]', el).indexOf(line) : -1,
      control: selectors.find(function (selector) { return active.matches(selector); }),
      flavor: active.getAttribute('data-flavor')
    };
  }
  function restoreCartFocus(saved, el) {
    if (!saved || !isOpen() || visible(saved.element)) return;
    var target;
    if (saved.key) {
      var lines = $$('[data-fcd-item]', el);
      var line = findLine(saved.key, el) || lines[Math.min(saved.index, lines.length - 1)];
      target = line && saved.control && $(saved.control, line);
      if (!target || target.disabled || !visible(target)) target = line && focusable(line)[0];
    } else if (saved.flavor) {
      target = $$('[data-fcd-upsell-add]', el).find(function (button) { return button.getAttribute('data-flavor') === saved.flavor; });
    }
    if (!target) target = el.classList.contains('empty') ? $('[data-fcd-shop-cta]', el) : $('.fcd-x', el);
    focus(target);
  }

  /* ── section refresh ──────────────────────────────────────────────── */
  // Serialize reads so a slower earlier response cannot replace newer totals.
  // A failed render resolves {ok:false}: an add may already have succeeded,
  // so callers must not repeat /cart/add.js merely to recover the drawer.
  function refresh(highlightLineKey) {
    refreshPending += 1;
    syncBusy();
    var task = refreshQueue.then(function () {
      var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      return request(base + '?sections=' + SECTION_ID).then(function (data) {
        var html = data && data[SECTION_ID];
        if (!html) throw new Error('The cart display is unavailable.');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('fizzyCartDrawer');
        var live = root();
        if (!fresh || !live) throw new Error('The cart display is unavailable.');
        var saved = captureFocus(live);
        var expanded = $$('[data-fcd-bundle-toggle][aria-expanded="true"]', live).map(function (button) {
          return button.closest('[data-fcd-item]').getAttribute('data-line-key');
        });
        var swaps = ['[data-fcd-list]', '[data-fcd-count]', '[data-fcd-summary]', '[data-fcd-checkout-total]', '.fcd-empty', '[data-fcd-upsell-region]'];
        if (swaps.some(function (selector) { return !$(selector, fresh) || !$(selector, live); })) {
          throw new Error('The cart display is incomplete.');
        }
        swaps.forEach(function (selector) { $(selector, live).innerHTML = $(selector, fresh).innerHTML; });
        live.classList.toggle('empty', fresh.classList.contains('empty'));
        expanded.forEach(function (key) {
          var line = findLine(key, live);
          var button = line && $('[data-fcd-bundle-toggle]', line);
          var list = line && $('.fcd-bundle-list', line);
          if (button && list) { button.setAttribute('aria-expanded', 'true'); list.hidden = false; }
        });
        if (highlightLineKey) {
          var added = findLine(highlightLineKey, live);
          if (added) {
            added.classList.add('just-added');
            setTimeout(function () { added.classList.remove('just-added'); }, 700);
          }
        }
        var count = parseInt(fresh.getAttribute('data-cart-item-count'), 10) || 0;
        live.setAttribute('data-cart-item-count', count);
        syncBubbles(count);
        stale = false;
        clearError();
        restoreCartFocus(saved, live);
        announce(count ? 'Cart updated. ' + count + (count === 1 ? ' item. Total ' : ' items. Total ') + $('[data-fcd-checkout-total]', live).textContent.trim() + '.' : 'Your cart is empty.');
        return { ok: true };
      }).catch(function (error) {
        stale = true;
        showError(highlightLineKey ? 'Your item was added, but the cart display could not refresh. Retry the display or view your full cart before adding again.' : 'Your cart could not refresh. Retry or view your full cart to check its current contents.', function () { return refresh(highlightLineKey); });
        return { ok: false, error: error };
      });
    }).finally(function () { refreshPending -= 1; syncBusy(); });
    refreshQueue = task.then(function () {}, function () {});
    return task;
  }

  /* ── line-item mutations ──────────────────────────────────────────── */
  function changeLine(key, newQty, lineEl) {
    if (mutationPending || refreshPending || stale) return Promise.resolve();
    mutationPending = true;
    clearError();
    if (lineEl) { lineEl.classList.add('is-busy'); lineEl.setAttribute('aria-busy', 'true'); }
    syncBusy();
    return request('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    }).then(function () { return refresh(); }).catch(function (error) {
      stale = true;
      var detail = error.name === 'AbortError' || error instanceof TypeError ? 'We could not confirm your change.' : error.message;
      showError(detail + ' Refresh your cart to check its current contents.', function () { return refresh(); });
    }).finally(function () {
      mutationPending = false;
      if (lineEl) { lineEl.classList.remove('is-busy'); lineEl.removeAttribute('aria-busy'); }
      syncBusy();
    });
  }

  /* ── add to cart ──────────────────────────────────────────────────── */
  function add(formDataOrObj) {
    var body, headers;
    if (formDataOrObj instanceof FormData) {
      body = formDataOrObj;
      headers = { 'Accept': 'application/json' };
    } else {
      body = JSON.stringify(formDataOrObj);
      headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    }
    return request('/cart/add.js', { method: 'POST', headers: headers, body: body })
      .then(function (added) {
        var lines = added && added.items || [];
        var key = added && added.key || lines.length && lines[lines.length - 1].key;
        return refresh(key).then(function () { open(); return added; });
      }).catch(function (error) {
        stale = true;
        showError('We could not confirm the addition. Refresh or view your full cart before adding again.', function () { return refresh(); });
        open();
        throw error;
      });
  }

  /* ── event wiring ─────────────────────────────────────────────────── */
  // Open triggers run in the CAPTURE phase on WINDOW: app embeds (Rebuy
  // Smart Cart) bind capturing handlers on document before this deferred
  // script runs and swallow real clicks on cart anchors. Window capture
  // fires before document capture regardless of registration order, so
  // our drawer always wins the click.
  window.addEventListener('click', function (e) {
    var openT = e.target.closest && e.target.closest('[data-open-cart], a.cart-pill');
    if (openT) {
      e.preventDefault();
      e.stopPropagation();
      open(openT);
    }
  }, true);

  document.addEventListener('click', function (e) {
    // Inside the drawer
    var el = root();
    if (!el || !el.contains(e.target)) return;

    if (e.target.closest('[data-fcd-menu]')) {
      e.preventDefault();
      if (!window.matchMedia('(max-width: 820px)').matches) return;
      var menuTrigger = $('.gh .menu-btn');
      var menu = document.getElementById('mobileMenu');
      if (!menuTrigger || !menu) return;
      // Release modal focus and scroll ownership before the menu takes over.
      close(false);
      focus(menuTrigger);
      if (!menu.classList.contains('open')) menuTrigger.click();
      return;
    }

    if (e.target.closest('[data-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var retry = e.target.closest('[data-fcd-retry]');
    if (retry) {
      e.preventDefault();
      if (!retry.disabled && retryAction) retryAction();
      return;
    }

    /* ── Bundle dropdown — expand/collapse the flavor list on a bundle line. */
    var bundleToggle = e.target.closest('[data-fcd-bundle-toggle]');
    if (bundleToggle) {
      e.preventDefault();
      var blist = bundleToggle.parentElement.querySelector('.fcd-bundle-list');
      var bopen = bundleToggle.getAttribute('aria-expanded') === 'true';
      bundleToggle.setAttribute('aria-expanded', bopen ? 'false' : 'true');
      if (blist) blist.hidden = bopen;
      return;
    }

    /* ── Upsell quick-add ─────────────────────────────────────────
       "Add one for me" — adds the real Ages 14+ / Try It Once variant of the
       chosen flavor (only when a real matching one-time variant exists). */
    var upsellBtn = e.target.closest('[data-fcd-upsell-add]');
    if (upsellBtn) {
      e.preventDefault();
      if (upsellBtn.disabled || mutationPending || refreshPending || stale) return;
      var upsellWrap = upsellBtn.closest('[data-fcd-upsell]');
      var variantId = upsellWrap && upsellWrap.getAttribute('data-variant-id');
      if (!variantId) {
        console.error('[FizzyIQ Upsell] missing data-variant-id on .fcd-upsell');
        return;
      }
      var flavorName = upsellBtn.getAttribute('data-flavor-name') || 'Berry Cherry';
      upsellBtn.disabled = true;
      // The section emits only a real one-time adult variant for this flavor.
      // Never fall back to a subscription-priced box parent without its plan.
      var adultVariantId = upsellBtn.getAttribute('data-variant-id');
      if (!adultVariantId) {
        upsellBtn.disabled = false;
        showError('This option is unavailable. Please choose your order on the product page.');
        return;
      }
      var addItem = { id: adultVariantId, quantity: 1 };
      add({ items: [addItem] })
        .catch(function (err) {
          console.error('[FizzyIQ Upsell] add failed', err);
        })
        .then(function () {
          /* Re-query the button because refresh() replaced the upsell
             markup — the original element reference is now detached. */
          var liveWrap = root() && root().querySelector('[data-fcd-upsell]');
          var liveBtn = liveWrap && liveWrap.querySelector('[data-flavor="' + upsellBtn.getAttribute('data-flavor') + '"]');
          if (liveBtn) liveBtn.disabled = false;
        });
      return;
    }

    // Empty-state "Shop Fizzy Focus" CTA — if we're already on the
    // linked page, just close the drawer instead of triggering a
    // no-op navigation. Otherwise let the anchor navigate normally.
    var shopCta = e.target.closest('[data-fcd-shop-cta]');
    if (shopCta) {
      try {
        var targetPath = new URL(shopCta.href, window.location.origin).pathname;
        if (window.location.pathname === targetPath) {
          e.preventDefault();
          close();
        }
      } catch (err) {
        // bad URL or no window.location — let the link do its default thing
      }
      return;
    }

    var line = e.target.closest('[data-fcd-item]');
    if (!line || mutationPending || refreshPending || stale) return;
    var key = line.getAttribute('data-line-key');
    var qtyEl = line.querySelector('[data-fcd-qty]');
    var qty = parseInt((qtyEl && qtyEl.textContent) || '1', 10);

    if (e.target.closest('[data-fcd-inc]')) {
      e.preventDefault();
      changeLine(key, qty + 1, line);
      return;
    }
    if (e.target.closest('[data-fcd-dec]')) {
      e.preventDefault();
      if (qty > 1) changeLine(key, qty - 1, line);
      return;
    }
    if (e.target.closest('[data-fcd-rm]')) {
      e.preventDefault();
      changeLine(key, 0, line);
      return;
    }
  });

  // Keep the keyboard within the custom modal and recover accidental app focus.
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    var panel = $('.fcd-panel', root());
    var controls = focusable(panel);
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (!first) { e.preventDefault(); focus(panel); return; }
    if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
      e.preventDefault(); focus(last);
    } else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
      e.preventDefault(); focus(first);
    }
  });
  document.addEventListener('focusin', function (e) {
    if (isOpen() && !$('.fcd-panel', root()).contains(e.target)) focus($('.fcd-x', root()));
  });
  window.addEventListener('resize', function () {
    if (isOpen() && !window.matchMedia('(max-width: 820px)').matches &&
        document.activeElement === $('[data-fcd-menu]', root())) {
      focus($('.fcd-x', root()));
    }
  }, { passive: true });
  // The inline discount handler also navigates to checkout. Capture its events
  // while the display is stale/updating so no old totals are presented as final.
  function stopStaleCheckout(e) {
    if (!root() || !(mutationPending || refreshPending || stale || root().classList.contains('empty'))) return;
    var target = e.target;
    var checkoutAction = target.closest && target.closest('[data-disc-apply], [data-fcd-checkout-form]');
    var discountEnter = e.type === 'keydown' && e.key === 'Enter' && target.matches('[data-disc-input]');
    if (checkoutAction || discountEnter) { e.preventDefault(); e.stopImmediatePropagation(); }
  }
  document.addEventListener('click', stopStaleCheckout, true);
  document.addEventListener('submit', stopStaleCheckout, true);
  document.addEventListener('keydown', stopStaleCheckout, true);

  /* ── public API ───────────────────────────────────────────────────── */
  window.FizzyCart = {
    open: open,
    close: close,
    refresh: refresh,
    add: add,
    FLAVOR_MAP: FLAVOR_MAP
  };

  // Initial setup: bubble sync + redundant direct scrim binding.
  // The delegated [data-close] handler above already closes on scrim
  // clicks — but a direct listener guarantees it works even if some
  // higher-priority page click handler ever swallows the bubbled event.
  function bootstrap() {
    var countEl = $('[data-fcd-count]');
    if (countEl) {
      var n = parseInt(countEl.textContent.replace(/[^\d]/g, ''), 10) || 0;
      syncBubbles(n);
    }
    if (root() && !isOpen()) root().setAttribute('inert', '');
    syncBusy();
    var scrim = document.querySelector('#fizzyCartDrawer .fcd-scrim');
    if (scrim) {
      scrim.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        close();
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
